import type { MeResponse } from "./api";

export function isProfileComplete(
	profile: MeResponse["profile"],
): boolean {
	if (!profile?.nickname?.trim()) return false;
	if (!profile?.gender) return false;
	if (!profile?.birthDate) return false;
	return true;
}
